import { actionAdmin } from '@/components/pages/ActionAdmin/ActionAdmin.i18n.ja'
import { clients } from '@/components/pages/Client/Clients.i18n.ja'
import { config } from '@/components/pages/ConfigTimeWork/Config.i18n.ja'
import { incident } from '@/components/pages/Incidents/Incident.i18n.ja'

import { admins } from './Admin/Admin.i18n.ja'
import { announcements } from './Announcements/Announcements.i18n.ja'
import { attendance } from './Attendance/Attendance.i18n.ja'
import { attendanceEmployee } from './AttendanceEmployee/AttendanceEmployee.i18n.ja'
import { attendanceLogs } from './AttendanceLogs/AttendanceLogs.i18n.ja'
import { clientDevice } from './ClientDevice/ClientDevice.i18n.ja'
import { customers } from './Customer/Customers.i18n.ja'
import { detergentHistories } from './DetergentHistories/DetergentHistories.i18n.ja'
import { detergents } from './Detergents/Detergents.i18n.ja'
import { employees } from './Employees/Employees.i18n.ja'
import { home } from './Home/Home.i18n.ja'
import { idCards } from './IdCards/IdCards.i18n.ja'
import { languages } from './Languages/Languages.i18n.ja'
import { login } from './Login/Login.i18n.ja'
import { machineParts } from './MachineParts/MachineParts.i18n.ja'
import { machines } from './Machines/Machines.i18n.ja'
import { notifications } from './Notifications/Notifications.i18n.ja'
import { operators } from './Operator/Operators.i18n.ja'
import { tankHistories } from './TankHistories/TankHistories.i18n.ja'
import { tanks } from './Tanks/Tanks.i18n.ja'
import { terminals } from './Terminals/Terminals.i18n.ja'
import { uniforms } from './Uniforms/Uniforms.i18n.ja'
import { washingCount } from './WashingCount/WashingCount.i18n.ja'
import { washingHistory } from './WashingHistory/WashingHistory.i18n.ja'
import { washingMachinePart } from './WashingMachinePart/WashingMachinePart.i18n.ja'
import { washingMethods } from './WashingMethods/WashingMethods.i18n.ja'

export const pages = {
  announcements,
  attendanceLogs,
  employees,
  idCards,
  languages,
  terminals,
  uniforms,
  login,
  admins,
  home,
  clientDevice,
  attendanceEmployee,
  attendance,
  config,
  clients,
  incident,
  actionAdmin,
  operators,
  customers,
  machines,
  machineParts,
  detergents,
  detergentHistories,
  washingMethods,
  washingCount,
  notifications,
  washingHistory,
  washingMachinePart,
  tanks,
  tankHistories,
}
